import { render } from "./ReceiverNew.vue?vue&type=template&id=f752881c&scoped=true"
import script from "./ReceiverNew.vue?vue&type=script&lang=js"
export * from "./ReceiverNew.vue?vue&type=script&lang=js"

import "./ReceiverNew.vue?vue&type=style&index=0&id=f752881c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f752881c"]])

export default __exports__